import { ExternalResource } from '../../helpers';
import { Generic, ShortlistStatus } from '../dictionary-service';

export interface CommentShortlist extends Generic.Entity {
  project: Generic.Item & { assigned?: Recruiter };
}

export interface Comment {
  id: number | null;
  addedBy: Recruiter;
  shortlist?: CommentShortlist;
  shortlistStatus?: ShortlistStatus.Item;
  shortlistStatusId?: number | null;
  shortlistStatusDate?: Date | string | null;
  comment: string | null;
  createdAt: Date | string | number;
  source?: Generic.Item | null;
}

export interface ExternalPublication {
  id: number;
  url: string;
  resource: ExternalResource;
}

export interface ShortlistsCounts {
  ai: number;
  hired: number;
  inbox: number;
  longList: number;
  notAccepted: number;
  notified: number;
  processing: number;
  reserve: number;
}

export interface StatisticItem {
  archived: number;
  cancelled: number;
  count: number;
  closedExternally: number;
  closedInternally: number;
  inProgress: number;
  new: number;
  paused: number;
  recruiterId: number;
  recruiterName: string;
}

export interface Statistic {
  total: Omit<StatisticItem, 'recruiterId' | 'recruiterName'>;
  items: StatisticItem[];
}

export enum StatusChangeState {
  NO_ENTRIES,
  NO_CHANGES,
  CHANGED,
  SUCCESS_CLOSED,
  UNSUCCESS_CLOSED,
}

export interface Recruiter extends Generic.Entity {
  email: string;
  firstName: string;
  lastName: string | null;
  name: string;
  telephone: string | null;
  image: string | null;
}

export interface StatusHistory extends Generic.Entity {
  portalId: number;
  projectId: number;
  statusId: number;
  changedAt?: string;
  changedBy?: number;
  statusDurationDays?: number;
  statusDurationIsCountable?: boolean;
}

export enum SearchCategory {
  Worker = 0,
  Specialist = 1,
  Manager = 2,
  TopManager = 3,
}
